<section class="bg-white !p-0" [variant]="invalid() ? 'destructive' : 'default'" hlmCard>
  <div class="gap-xl !p-lg flex justify-between" hlmCardContent>
    <ng-content />
    <div>
      <a [routerLink]="['.']" [queryParams]="{ i: index() }" hlmBtn variant="secondary">Modifier</a>
    </div>
  </div>
</section>
@if (invalid()) {
  <p class="component-small-medium text-content-secondary gap-xxs mt-xs flex items-center">
    <span class="text-feedback-negative-main flex"><ng-icon hlm name="lucideCircleAlert" size="sm" /></span>
    Il est nécessaire de renseigner les champs requis pour pouvoir publier.
  </p>
}
